import React, { Component} from 'react';
import Obfuscate from 'react-obfuscate';
import globals from "../globals";

class SlideFormErrorBoundary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            hasError: false
        };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true
        });

        globals.handleException(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div>
                    <h2>Whoops!</h2>
                    <p>There was a bit of a mix up and something went wrong. Our team will put down their coffees and look into this right away.</p>
                    <p>
                        For now, you can contact us directly at&nbsp;
                        <Obfuscate
                            email="corporatesales@exetel.com.au"
                            headers={{
                                subject: 'Form Error - Direct Enquiry'
                            }}
                        />
                        &nbsp;or try going <a href="/">back home</a>.
                    </p>
                </div>
            );
        }

        return this.props.children;
    }

}

export default SlideFormErrorBoundary;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/SlideFormErrorBoundary.js